import React from "react";
import * as Yup from "yup";
import {
  Button,
  Dialog as MUIDialog,
  Grid,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import { Cancel } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { useAxios, useComponent } from "../../../../hooks";
import AddCommentForm from "./AddCommentForm";

const useStyles = makeStyles(() => ({
  paper: { minWidth: "400px" },
}));

export default function AddComments({
  popUp,
  setPopUp,
  setAddComments,
  pagePermissions,
  formData,
}) {
  const axios = useAxios();
  const classes = useStyles();
  const { alert } = useComponent();

  const handleClose = () => {
    setPopUp({
      state: false,
      data: {},
    });
  };

  return (
    <React.Fragment>
      <MUIDialog
        classes={{ paper: classes.paper }}
        open={popUp.state}
        onClose={handleClose}
      >
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: "1px solid #cbcbcb",
          }}
        >
          <Grid style={{ padding: "16px 24px" }} item xs={8}>
            <Typography variant="h5">{"Add Comment"}</Typography>
          </Grid>

          <Grid item xs={4}>
            <IconButton
              disableRipple
              style={{ float: "right", padding: "16px 24px" }}
              onClick={handleClose}
            >
              <Cancel />
            </IconButton>
          </Grid>
        </Grid>

        <Formik
          initialValues={popUp.data}
          validateOnMount
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={(formData, { setSubmitting }) => {
            var method = "POST";
            if (formData.comment_id) {
              method = "PATCH";
            }
            axios({
              url: "/leads/comments",
              method: method,
              data: formData,
              disableRedirect: true,
            }).then((response) => {
              if (response.status) {
                setAddComments(response.data._id);
                alert.success(response.message?.displayMessage);
              }
              setSubmitting(false);
              handleClose();
            });
          }}
        >
          {(dialogFormikProps) => (
            <React.Fragment>
              <DialogContent
                style={{
                  height: "270px",
                  paddingTop: "10px",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      variant="caption1"
                      style={{ color: "rgb(128, 128, 128)" }}
                    >
                      Add a comment for you lead so that it can be used later.
                    </Typography>
                  </Grid>

                  <AddCommentForm
                    pagePermissions={pagePermissions}
                    dialogFormikProps={dialogFormikProps}
                  />
                </Grid>
              </DialogContent>

              <DialogActions style={{ padding: "12px 24px 24px" }}>
                {!dialogFormikProps.values?.comment_id && (
                  <Grid container spacing={2}>
                    <Grid item>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleClose}
                      >
                        Cancel
                      </Button>
                    </Grid>

                    <Grid item xs />

                    <Grid item xs style={{ textAlign: "end" }}>
                      <Button
                        onClick={dialogFormikProps.handleSubmit}
                        variant="contained"
                        color="primary"
                        disabled={
                          dialogFormikProps.dirty
                            ? dialogFormikProps.isSubmitting ||
                              !dialogFormikProps.isValid
                            : !dialogFormikProps.dirty
                        }
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </DialogActions>
            </React.Fragment>
          )}
        </Formik>
      </MUIDialog>
    </React.Fragment>
  );
}

const validationSchema = Yup.object().shape({
  text: Yup.string().required("This field is required."),
});
